import { MovementPhase } from './movementData'
// Define types for convoy route segments
export type ConvoyRouteSegment = {
  id: string
  name: string
  day: number
  timeframe: string
  coordinates: [number, number][] // Array of [lat, lng] pairs
  description: string
}
// Define types for points of interest
export type PointOfInterest = {
  id: string
  name: string
  code: string
  location: string
  coordinates: [number, number] // [lat, lng]
  icon: 'fuel' | 'radio' | 'shield' | 'flag'
  tooltip: string
  day: number
}
// Convoy route data
export const convoyRouteSegments: ConvoyRouteSegment[] = [
  {
    id: 'day1',
    name: 'Day 1: Presidio to Fort Stockton',
    day: 1,
    timeframe: '0-24 hours',
    coordinates: [
      [29.5607, -104.3729], // Presidio
      [30.3094, -104.0177], // Marfa
      [30.8941, -102.8793], // Fort Stockton
    ],
    description:
      'Initial movement from Presidio through Marfa to Fort Stockton',
  },
  {
    id: 'day2',
    name: 'Day 2: Fort Stockton to Sanderson',
    day: 2,
    timeframe: '24-48 hours',
    coordinates: [
      [30.8941, -102.8793], // Fort Stockton
      [30.1422, -102.3979], // Sanderson
    ],
    description: 'Continued movement from Fort Stockton to Sanderson',
  },
  {
    id: 'day3',
    name: 'Day 3: Sanderson to Del Rio',
    day: 3,
    timeframe: '48-72 hours',
    coordinates: [
      [30.1422, -102.3979], // Sanderson
      [29.3627, -100.8968], // Del Rio
    ],
    description: 'Movement from Sanderson to Del Rio',
  },
  {
    id: 'day4',
    name: 'Day 4: Del Rio to Eagle Pass',
    day: 4,
    timeframe: '72-96 hours',
    coordinates: [
      [29.3627, -100.8968], // Del Rio
      [28.7091, -100.4995], // Eagle Pass
    ],
    description: 'Movement from Del Rio to Eagle Pass',
  },
  {
    id: 'day5',
    name: 'Day 5: Eagle Pass to Laredo',
    day: 5,
    timeframe: '96-120 hours',
    coordinates: [
      [28.7091, -100.4995], // Eagle Pass
      [27.5306, -99.4803], // Laredo
    ],
    description: 'Movement from Eagle Pass to Laredo',
  },
  {
    id: 'day6',
    name: 'Day 6: Laredo to McAllen',
    day: 6,
    timeframe: '120-144 hours',
    coordinates: [
      [27.5306, -99.4803], // Laredo
      [26.2033, -98.23], // McAllen
    ],
    description: 'Movement from Laredo to McAllen',
  },
  {
    id: 'day7',
    name: 'Day 7: McAllen to Brownsville',
    day: 7,
    timeframe: '144-168 hours',
    coordinates: [
      [26.2033, -98.23], // McAllen
      [25.9017, -97.4975], // Brownsville
    ],
    description: 'Final movement from McAllen to Brownsville',
  },
]
// Alternative route for day 1
export const alternativeRouteSegment: ConvoyRouteSegment = {
  id: 'day1-alt',
  name: 'Day 1 (Alt): Presidio to Alpine',
  day: 1,
  timeframe: '0-24 hours',
  coordinates: [
    [29.5607, -104.3729], // Presidio
    [30.3094, -104.0177], // Marfa
    [30.3584, -103.6614], // Alpine
  ],
  description: 'Alternative route from Presidio through Marfa to Alpine',
}
// Points of interest data
export const pointsOfInterest: PointOfInterest[] = [
  {
    id: 'frpa',
    name: 'Forward Resupply Point Alpha',
    code: 'FRPA',
    location: 'Fort Stockton',
    coordinates: [30.8941, -102.8793],
    icon: 'fuel',
    tooltip: 'Primary overnight resupply and refuel location (Day 1)',
    day: 1,
  },
  {
    id: 'frpa-alt',
    name: 'Forward Resupply Point Alpha (Alt)',
    code: 'FRPA-ALT',
    location: 'Alpine',
    coordinates: [30.3584, -103.6614],
    icon: 'fuel',
    tooltip: 'Alternative overnight resupply and refuel location (Day 1)',
    day: 1,
  },
  {
    id: 'cnb',
    name: 'Coordination Node Bravo',
    code: 'CNB',
    location: 'Del Rio',
    coordinates: [29.3627, -100.8968],
    icon: 'radio',
    tooltip: 'Command checkpoint and logistics sync (Day 3)',
    day: 3,
  },
  {
    id: 'scp-c',
    name: 'Security Control Point Charlie',
    code: 'SCP-C',
    location: 'Laredo',
    coordinates: [27.5306, -99.4803],
    icon: 'shield',
    tooltip: 'Urban transit node with elevated security posture (Day 5)',
    day: 5,
  },
  {
    id: 'acg',
    name: 'Arrival Control Group',
    code: 'ACG',
    location: 'Brownsville',
    coordinates: [25.9017, -97.4975],
    icon: 'flag',
    tooltip: 'Arrival, staging, and mission completion zone (Day 7)',
    day: 7,
  },
]
// Helper function to get the appropriate phase for a given day
export const getDayPhase = (day: number): MovementPhase => {
  if (day <= 1) return 'Phase Line 24 – Staging Nodes'
  if (day <= 2) return 'Phase Line 48 – Route Extension'
  if (day <= 3) return 'Phase Line 72 – Node Expansion'
  return 'Phase Line 96 – Sustainment Overlay'
}
// Colors for route segments
export const routeColors = {
  default: '#3B82F6', // Blue
  active: '#059669', // Green
  future: '#9CA3AF', // Gray
  alternate: '#8B5CF6', // Purple
}
